'use client';

import { useMemo } from 'react';

import { CareerExplorerRecommendationsBody } from './CareerExplorerRecommendationsBody';
import { CareerExplorerRecommendationsShell } from './CareerExplorerRecommendationsShell';
import type { CareerExplorerRecommendationsProps } from './types';
import { visibleCareerExplorerPrograms } from './visibility';

export const CareerExplorerRecommendations = ({
  emptyMessage = 'No recommendations are available right now.',
  hideWhenEmpty = true,
  maxRecommendations,
  programs,
  recommendationReason,
  title,
  viewAllHref,
  viewAllLabel,
}: CareerExplorerRecommendationsProps) => {
  const validPrograms = useMemo(
    () => visibleCareerExplorerPrograms(programs, maxRecommendations),
    [maxRecommendations, programs],
  );

  if (validPrograms.length === 0 && hideWhenEmpty) {
    return null;
  }

  return (
    <CareerExplorerRecommendationsShell title={title}>
      <CareerExplorerRecommendationsBody
        programs={validPrograms}
        recommendationReason={recommendationReason}
        emptyMessage={emptyMessage}
        viewAllHref={viewAllHref}
        viewAllLabel={viewAllLabel}
      />
    </CareerExplorerRecommendationsShell>
  );
};
